"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames_1 = require("../../utilities/classNames");
var icon_1 = require("./../display/icon");
var Button = /** @class */ (function (_super) {
    tslib_1.__extends(Button, _super);
    function Button() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, pending = _a.pending;
            if (onClick && !pending) {
                onClick(e);
            }
        };
        return _this;
    }
    Button.prototype.focus = function () {
        if (this.input) {
            this.input.focus();
        }
    };
    Button.prototype.blur = function () {
        if (this.input) {
            this.input.blur();
        }
    };
    Button.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClick = _a.onClick, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, className = _a.className, rounded = _a.rounded, pending = _a.pending, disabled = _a.disabled, type = _a.type, children = _a.children, attrs = tslib_1.__rest(_a, ["onClick", "leftIcon", "rightIcon", "className", "rounded", "pending", "disabled", "type", "children"]);
        var classes = classNames_1.ClassHelpers.classNames("btn", className, {
            "rounded": rounded,
            "icon-button-left": leftIcon !== undefined,
            "icon-button-right": rightIcon !== undefined,
            "pending": pending,
        });
        return (React.createElement("button", tslib_1.__assign({ disabled: pending || disabled, type: type || "button", onClick: this.handleClick }, attrs, { ref: function (r) { return _this.input = r; }, className: classes }),
            leftIcon && React.createElement(icon_1.Icon, { className: "left-icon", icon: leftIcon }),
            children,
            rightIcon && React.createElement(icon_1.Icon, { className: "right-icon", icon: rightIcon })));
    };
    return Button;
}(React.Component));
exports.Button = Button;
